import { ISaveCargoTreinamentoUseCase } from "../../../presentation/useCases/create/save_cargo_treinamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * SaveCargoTreinamentoUseCase
 */

export class SaveCargoTreinamentoUseCase implements ISaveCargoTreinamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async saveCargoTreinamento(
    idTreinamento: number,
    cargoIds: number[],
  ): Promise<void> {
    await this.repository.saveCargoTreinamento(
      idTreinamento,
      cargoIds,
    );
  }
}
